module.exports = __webpack_public_path__ + "img/beneficiaires.467e19c4.svg";